import { isArray } from 'lodash';
import * as actionTypes from './workspacePreviewActionTypes';
import piction from '../utils/piction';
import { SESSION_EXPIRED_MESSAGE } from '../constants/sessionStateTypes';
import { sessionExpired } from './session';

export const retrieveWorkspaceRequest = (
  requestPromise,
  workspaceID,
  workspaceName,
  workspaceDescription,
  workspaceAncestorIDList
) => ({
  type: actionTypes.WORKSPACE_PREVIEW_RETRIEVE_REQUEST,
  requestPromise,
  workspaceID,
  workspaceName,
  workspaceDescription,
  workspaceAncestorIDList,
});

export const retrieveWorkspaceSuccess = (
  workspaceID,
  workspaceName,
  workspaceDescription,
  umoList = [],
  workspaceAncestorIDList
) => ({
  type: actionTypes.WORKSPACE_PREVIEW_RETRIEVE_SUCCESS,
  workspaceID,
  umoList,
  workspaceName,
  workspaceDescription,
  workspaceAncestorIDList,
});

export const retrieveWorkspaceFailure = (
  workspaceID,
  err
) => ({
  type: actionTypes.WORKSPACE_PREVIEW_RETRIEVE_FAILURE,
  workspaceID,
  err,
});

export const selectWorkspace = (
  workspaceID, workspaceName, workspaceDescription, workspaceAncestorIDList
) =>
  function selectWorkspaceDispatch(dispatch, getState) {
    const callData = {
      METADATA: 'FALSE',
      ORIGINAL_URLS: 'TRUE',
      SHOW_SORT_VAL: 'TRUE',
      RETURN_SORT_AS_NUMBERS: 'TRUE',
      METATAGS: getState().umoGallery.get('metatags'),
      FORCE_REFRESH: 'TRUE',
      OS: 'Win32',
      CHECK_PARENT_TOT: 'TRUE',
      MAXROWS: '200',
      START: '0',
    };

    const promise = piction.getUMOs(`IN_CATEGORY:"${workspaceID}"`, callData)
      .then((res) => {
        dispatch(
          retrieveWorkspaceSuccess(
            workspaceID, workspaceName, workspaceDescription, res.res.a.r, workspaceAncestorIDList
          )
        );
        return res;
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(retrieveWorkspaceFailure(workspaceID, err));
        }
        return err;
      });

    dispatch(
      retrieveWorkspaceRequest(
        promise, workspaceID, workspaceName, workspaceDescription, workspaceAncestorIDList
      )
    );
    return promise;
  };

export const selectToggle = (umoIDs = [], isSelect) => ({
  type: actionTypes.WORKSPACE_PREVIEW_SELECT_TOGGLE,
  umoIDList: isArray(umoIDs) ? umoIDs : [umoIDs],
  isSelect,
});

export const selectAll = () => ({
  type: actionTypes.WORKSPACE_PREVIEW_SELECT_ALL,
});

export const deselectAll = () => ({
  type: actionTypes.WORKSPACE_PREVIEW_DESELECT_ALL,
});
